import axios from './axiosConfig';
import { store } from '../../index';
import i18n from '../../i18n';
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

const API_URL = process.env.NODE_ENV === 'production'
  ? "https://api.test.raborisk.ai"
  : "http://localhost:3000";

const PYTHON_API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.ai.raborisk.ai"
  : "https://api.ai.raborisk.ai";

export const TOGGLE_CHATBOT = 'TOGGLE_CHATBOT';
export const SHOW_CHATBOT = 'SHOW_CHATBOT';
export const HIDE_CHATBOT = 'HIDE_CHATBOT';


export const toggleChatbot = () => ({ type: TOGGLE_CHATBOT });
export const showChatbot = () => ({ type: SHOW_CHATBOT });
export const hideChatbot = () => ({ type: HIDE_CHATBOT });

export const shareChat = async (chat_id, user_id) => {
  const res = await axios.post(
    `${API_URL}/api/chat/share`,
    { chat_id, user_id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );

  return res.data;
};

export const sendChatMessageNode = (message, chatId = null) => {
  return (dispatch) => {
    dispatch({ type: "CHATBOT_MESSAGE_SEND_START" });

    let finalChatId = chatId;

    axios
      .post(API_URL + "/api/chat/add_chat", {
        title: message?.trim()?.slice(0, 60) || "New Chat",
      })
      .then(({ data }) => {
        if (!finalChatId) finalChatId = data.chat_id;

        return axios.post(API_URL + "/api/chat/add_chat_message", {
          chatId: finalChatId,
          sender: "user",
          senderName: "You",
          messageText: message,
        });
      })
      .then(() => {
        dispatch({ type: "CHATBOT_MESSAGE_SEND_START_BOT" });

        return axios.post(API_URL + "/api/ai/chat", { message });
      })
      .then(({ data }) => {
        const botReply = data.reply || "";

        dispatch({
          type: "CHATBOT_MESSAGE_PARTIAL",
          payload: botReply,
        });

        dispatch({
          type: "CHATBOT_MESSAGE_SEND_SUCCESS",
          payload: botReply,
        });

        return axios.post(API_URL + "/api/chat/add_chat_message", {
          chatId: finalChatId,
          sender: "bot",
          senderName: "Rabo",
          messageText: botReply,
        });
      })
      .catch((error) => {
        console.error("Chatbot message error:", error);

        dispatch({
          type: "CHATBOT_MESSAGE_SEND_FAILURE",
          payload: error.message,
        });
      });
  };
};

export const addChat = (title = "New Chat") => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .post(
        API_URL + "/api/chat/add_chat",
        { title },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_ADD_CHAT",
          payload: {
            chat_id: data.chat_id,
            title,
          },
        });

        return data;
      })
      .catch((error) => {
        console.error("Error creating chat:", error);
        throw error;
      });
  };
};

export const getChats = () => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .get(API_URL + "/api/chat/get_chats", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_SET_CHATS",
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        console.error("Error fetching chats:", error);
        throw error;
      });
  };
};

export const renameChat = (chatId, title) => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .post(
        API_URL + "/api/chat/rename_chat",
        { chatId, title },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_RENAME_CHAT",
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        // rename is non-critical; swallow so callers don't break on stale chatIds
        console.warn("renameChat failed (non-fatal):", error?.response?.status, error?.response?.data?.error);
      });
  };
};


export const getChatMessages = (chatId) => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .get(API_URL + "/api/chat/get_chat_messages", {
        params: { chatId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_SET_MESSAGES",
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        console.error("Error fetching chat messages:", error);
        throw error;
      });
  };
};


export const resetActiveChat = () => {
  return (dispatch) => {
    dispatch({
      type: "RESET_ACTIVE_CHAT",
    });
  }
}

export const setActiveChat = (chatID) => {
  ////console.log("setting_i ", chatID)
  return (dispatch) => {
    dispatch({
      type: "SET_ACTIVE_CHAT",
      payload: chatID
    });
  }
}

export const deleteChat = (chatId) => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .post(
        API_URL + "/api/chat/delete_chat",
        { chatId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_DELETE_CHAT",
          payload: data.chat_id,
        });
        return data;
      })
      .catch((error) => {
        console.error("Error deleting chat:", error);
        throw error;
      });
  };
};

const resizeImageToBase64 = (file, maxDim = 1024) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      canvas.getContext("2d").drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL(file.type).split(",")[1]);
    };
    img.onerror = reject;
    img.src = url;
  });

export const sendChatMessage = (message, chatId = null, files = [], history = []) => {
  return async (dispatch) => {
    dispatch({ type: "CHATBOT_MESSAGE_SEND_START" });

    try {
      let finalChatId = chatId;

      // 1) create chat if needed
      if (!finalChatId) {
        const { data } = await axios.post(API_URL + "/api/chat/add_chat", {
          title: message?.trim()?.slice(0, 60) || "New Chat",
        });

        finalChatId = data.chat_id;
      }

      // 2) upload any image attachments to S3 and save user message
      const attachments = [];
      if (files && files.length > 0) {
        for (const file of files) {
          if (file.type.startsWith('image/')) {
            try {
              const form = new FormData();
              form.append('file', file);
              const { data } = await axios.post(`${API_URL}/api/chat/upload_image`, form, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
              });
              attachments.push({ name: file.name, type: file.type, url: data.url });
            } catch (e) {
              console.error('Failed to upload chat image:', e);
            }
          }
        }
      }

      try {
        await axios.post(API_URL + "/api/chat/add_chat_message", {
          chatId: finalChatId,
          sender: "user",
          senderName: "You",
          messageText: message,
          attachments: attachments.length > 0 ? attachments : undefined,
        });
      } catch (msgErr) {
        if (msgErr?.response?.status === 404) {
          // The chat was deleted or the ID is stale — create a fresh chat
          const { data: freshChat } = await axios.post(API_URL + "/api/chat/add_chat", {
            title: message?.trim()?.slice(0, 60) || "New Chat",
          });
          finalChatId = freshChat.chat_id;
          await axios.post(API_URL + "/api/chat/add_chat_message", {
            chatId: finalChatId,
            sender: "user",
            senderName: "You",
            messageText: message,
            attachments: attachments.length > 0 ? attachments : undefined,
          });
        } else {
          throw msgErr;
        }
      }

      // 3) start bot row in UI
      dispatch({ type: "CHATBOT_MESSAGE_SEND_START_BOT" });

      // Process attached files: extract text from PDFs/text files, base64-encode images.
      let finalMessage = message;
      const images = [];

      if (files && files.length > 0) {
        const isImage = (f) => f.type.startsWith("image/");

        const processFile = async (file) => {
          if (isImage(file)) {
            // Resize large images before encoding to keep payload reasonable
            const base64 = await resizeImageToBase64(file, 1024);
            images.push({ base64, mimeType: file.type, name: file.name });
            return "";
          }
          if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
            try {
              const arrayBuffer = await file.arrayBuffer();
              const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
              const pages = await Promise.all(
                Array.from({ length: pdf.numPages }, (_, i) =>
                  pdf.getPage(i + 1).then((p) => p.getTextContent()).then((c) =>
                    c.items.map((item) => item.str).join(" ")
                  )
                )
              );
              return `\n\n[The user uploaded "${file.name}". Here is its full extracted text content:\n${pages.join("\n").slice(0, 8000)}\n]`;
            } catch {
              return `\n\n[Attached file: ${file.name} — could not extract text]`;
            }
          }
          const textTypes = ["text/plain", "text/csv", "application/json"];
          if (textTypes.includes(file.type) || file.name.endsWith(".txt") || file.name.endsWith(".csv")) {
            const text = await file.text();
            return `\n\n[The user uploaded "${file.name}". Here is its full extracted text content:\n${text.slice(0, 8000)}\n]`;
          }
          return `\n\n[Attached file: ${file.name} (${file.type || "binary"}) — content not extractable]`;
        };

        const parts = await Promise.all(files.map(processFile));
        finalMessage = message + parts.filter(Boolean).join("");
      }

      const abortController = new AbortController();
      const fetchTimeout = setTimeout(() => abortController.abort(), 30000);

      const res = await fetch(PYTHON_API_URL + "/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        signal: abortController.signal,
        body: JSON.stringify({
          message: finalMessage,
          images: images.length > 0 ? images : undefined,
          history: history.length > 0 ? history : undefined,
          token: store.getState().auth?.token || undefined,
          language: i18n.language || "tr",
          subdomain: (() => { const h = window.location.hostname; if (h === 'localhost' || h === '127.0.0.1') return 'test'; const p = h.split('.'); return p.length >= 3 && p[0] !== 'www' ? p[0] : ''; })(),
        }),
      });
      clearTimeout(fetchTimeout);

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const reader = res.body.getReader();
      const decoder = new TextDecoder();

      let full = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        full += chunk;

        dispatch({
          type: "CHATBOT_MESSAGE_PARTIAL",
          payload: chunk,
        });
      }

      const finalReply = full.trim();

      if (!finalReply) {
        dispatch({
          type: "CHATBOT_MESSAGE_SEND_FAILURE",
          payload: "empty_response",
          errorMessage: "No response received. Please try again.",
        });
        return;
      }

      dispatch({
        type: "CHATBOT_MESSAGE_SEND_SUCCESS",
        payload: finalReply,
      });

      // 4) save bot message
      if (finalReply) {
        await axios.post(API_URL + "/api/chat/add_chat_message", {
          chatId: finalChatId,
          sender: "bot",
          senderName: "Rabo",
          messageText: finalReply,
        });
      }

      return {
        reply: finalReply,
        chatId: finalChatId,
      };

    } catch (error) {
      console.error("Chat error:", error);

      const isTimeout = error.name === 'AbortError';
      dispatch({
        type: "CHATBOT_MESSAGE_SEND_FAILURE",
        payload: error.message,
        errorMessage: isTimeout
          ? "The request timed out. Please try again."
          : "Something went wrong. Please try again.",
      });
    }
  };
};

export const saveChatMessage = (chatId, sender, senderName, messageText) => {
  return async () => {
    await axios.post(API_URL + "/api/chat/add_chat_message", {
      chatId,
      sender,
      senderName,
      messageText,
    });
  };
};

export const generateAuditPlan = (chatId, departments, language = 'en') => {
  return async (dispatch) => {
    dispatch({ type: "CHATBOT_MESSAGE_SEND_START_BOT" });

    try {
      const { data } = await axios.post(PYTHON_API_URL + "/generate_audit_plan", {
        departments: (departments || []).map((d) => ({
          name: d.name,
          company_name: d.company_name,
        })),
        language,
      });

      const plan = data?.plan || '';

      dispatch({ type: "CHATBOT_MESSAGE_SEND_SUCCESS", payload: plan });

      if (plan) {
        await axios.post(API_URL + "/api/chat/add_chat_message", {
          chatId,
          sender: "bot",
          senderName: "Rabo",
          messageText: plan,
        });
      }

      return plan;
    } catch (error) {
      console.error("Failed to generate audit plan:", error);
      dispatch({
        type: "CHATBOT_MESSAGE_SEND_FAILURE",
        payload: error.message,
        errorMessage: "Could not generate the audit plan. Please try again.",
      });
    }
  };
};


